import { createContext, useContext } from 'react';
var RcPortalWindowContext = createContext({
    document: 
    // directly access `document` will cause error in next.js
    typeof globalThis !== 'undefined' ? globalThis.document : window.document,
});
var useRcPortalWindowContext = function () { return useContext(RcPortalWindowContext); };
export { RcPortalWindowContext, useRcPortalWindowContext };
